import { render, staticRenderFns } from "./SalesRecord3.vue?vue&type=template&id=625e454d&scoped=true&"
import script from "./SalesRecord3.vue?vue&type=script&lang=js&"
export * from "./SalesRecord3.vue?vue&type=script&lang=js&"
import style0 from "./SalesRecord3.vue?vue&type=style&index=0&id=625e454d&prod&lang=scss&scoped=true&"
import style1 from "./SalesRecord3.vue?vue&type=style&index=1&id=625e454d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "625e454d",
  null
  
)

export default component.exports